import { render, staticRenderFns } from "./annexadd.vue?vue&type=template&id=ac010226&"
import script from "./annexadd.vue?vue&type=script&lang=js&"
export * from "./annexadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports